import React, { useEffect } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaTimes } from "react-icons/fa";

const Myswal = withReactContent(Swal);

const AcceptChangesModal = ({ isOpen, setIsOpen, onConfirm }) => {
  useEffect(() => {
    if (isOpen) {
      // Add class to body to show custom backdrop
      document.body.classList.add('accept-modal-open');
      
      Myswal.fire({
        width: "395px",
        html: (
          <div>
            <div className="d-flex justify-content-end">
              <FaTimes
                color="#50a193"
                size={15}
                fontWeight={"bolder"}
                className="cursor-pointer"
                onClick={() => Myswal.close()}
              />
            </div>
            <p className="fs-15 mb-43 mt-3">Accept all changes?</p>
            <div className="d-flex justify-content-between">
              <button
                className="btn btn_outline_danger overlay-btn small-text"
                onClick={() => Myswal.close()}
              >
                GO BACK
              </button>
              <button
                className="btn btn-outline-primary overlay-btn small-text"
                onClick={() => {
                  Myswal.close();
                  if (onConfirm) {
                    onConfirm();
                  }
                }}
              >
                YES
              </button>
            </div>
          </div>
        ),
        focusConfirm: false,
        showConfirmButton: false,
        backdrop: false,
        customClass: {
          container: 'swal-no-backdrop',
          popup: 'swal-popup-shadow'
        },
        willClose: () => {
          document.body.classList.remove('accept-modal-open');
          setIsOpen(false);
        },
      });
    }
  }, [isOpen, setIsOpen, onConfirm]);

  return null;
};

export default AcceptChangesModal;

